import React from "react";
import "./Pagination.scss";
import { RectangleTextured, ArrowTextured } from "../images/index";

interface PaginationProps {
  currentPage: number;
  totalPages: number;
  onPageChange: (page: number) => void;
}

export const Pagination: React.FC<PaginationProps> = ({
  currentPage,
  totalPages,
  onPageChange,
}) => {
  const getPageNumbers = () => {
    const maxVisiblePages = 9;
  
    if (totalPages <= maxVisiblePages) {
      return Array.from({ length: totalPages }, (_, i) => i + 1);
    }
  
    let startPage = Math.max(1, currentPage - Math.floor((maxVisiblePages - 1) / 2));
    let endPage = Math.min(totalPages, startPage + maxVisiblePages - 1);
  
    // If the calculated window is pushed against the end (totalPages)
    // and is shorter than maxVisiblePages, adjust startPage to expand the window leftwards.
    if (endPage === totalPages && (endPage - startPage + 1 < maxVisiblePages)) {
      startPage = Math.max(1, endPage - maxVisiblePages + 1);
    }
  
    const pages = [];
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }
    return pages;
  };

  return (
    <div className="pagination">

      <button
        className="arrow left"
        onClick={() => onPageChange(currentPage - 1)}
        disabled={currentPage === 1}
      >
        <ArrowTextured />
      </button>

      <button
        className="first-page"
        onClick={() => onPageChange(1)}
        disabled={currentPage === 1}
      >
        First
      </button>

      {getPageNumbers().map((page) => (
        <button
          key={page}
          className={`page ${page === currentPage ? "active" : ""} ${currentPage === 1 ? "page-one" : ""} ${currentPage === totalPages ? "page-last" : ""}`}
          onClick={() => onPageChange(page)}
        >
          {page === currentPage && <RectangleTextured />}
          <span>{page}</span>
        </button>
      ))}

      <button
        className="last-page"
        onClick={() => onPageChange(totalPages)}
        disabled={currentPage === totalPages}
      >
        Last
      </button>

      <button
        className="arrow right"
        onClick={() => onPageChange(currentPage + 1)}
        disabled={currentPage === totalPages}
      >
        <ArrowTextured />
      </button>
    </div>
  );
};
